import { useTranslation } from 'react-i18next'

import { Text } from '@mercai/clever'

import { CreditSummaryCardProps } from './credit-summary-card.type'

import styles from './credit-summary-card.module.css'
import { formatCurrency } from '@/helpers'

export const CreditSummaryCard = ({ profile }: CreditSummaryCardProps) => {
  const { t } = useTranslation('screenProfileShow')

  return (
    <div className={styles.core}>
      <div className={styles.item}>
        <Text variant="title-medium" className={styles.greened}>
          {t('profileCreditApprovedLabel')}
        </Text>
        <Text variant="title-medium">
          ${' '}
          {formatCurrency(
            Number(profile?.financeProfile?.totalCreditAmount),
            'es-MX',
            'USD',
          )}{' '}
        </Text>
      </div>

      <div className={styles.item}>
        <Text variant="title-medium" className={styles.greened}>
          {t('profileCreditUsingLabel')}
        </Text>
        <Text variant="title-medium">
          ${' '}
          {formatCurrency(
            Number(profile?.financeProfile?.totalCreditInUse),
            'es-MX',
            'USD',
          )}{' '}
        </Text>
      </div>

      <div className={styles.item}>
        <Text variant="title-medium" className={styles.greened}>
          {t('profileCreditAvailableLabel')}
        </Text>
        <Text variant="title-medium">
          ${' '}
          {formatCurrency(
            Number(profile?.financeProfile?.totalCreditAmount) -
              Number(profile?.financeProfile?.totalCreditInUse),
            'es-MX',
            'USD',
          )}{' '}
        </Text>
      </div>
    </div>
  )
}
